import React from "react";

const Checkbox = React.forwardRef((props, ref) => {
  return (
    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
      <div className="inline-flex items-center relative">
        <input
          name={props.name}
          type="checkbox"
          checked={props.checked}
          className="opacity-0 absolute checkbox"
          ref={ref}
          disabled={props.disabled}
          onChange={props.onChange}
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill={props.disabled ? "#edf2f7" : "none"}
          stroke={props.disabled ? "#a0aec0" : "currentColor"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="mr-2 unchecked">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill={props.disabled ? "#edf2f7" : "none"}
          stroke={props.disabled ? "#a0aec0" : "currentColor"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="mr-2 checked">
          <polyline points="9 11 12 14 22 4"></polyline>
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
        </svg>
        <span>{props.label}</span>
      </div>
    </label>
  );
});

export default Checkbox;
